import React, { useMemo } from 'react';
import { HolidayActivityFill } from "./WallPlannerActivityBlocks";
import { daysBetween } from '@shared/utils/DateUtils';
import { Moment } from "moment";
import { Birthday } from '@shared/models/user.models';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { CustomLeaveInfoPopup } from "./CustomLeaveInfoPopup";
import moment from "moment";
import { PopupPosition } from "./HolidayInfoAndApprovalPopup";
import { SideOfDay } from '@features/whereabouts/models/movements.models';
import { WhereaboutsIconOutline } from '@shared/ui/atoms/WhereaboutsIconOutline';
import { useFillHover } from "./useFillHover";

export function CustomLeaveBlock(props: Props) {
  const {activity, firstDateOnCalendar} = props;
  const days = 1;

  const allDay = useFillHover();
  const am = useFillHover();
  const pm = useFillHover();

  const popupPositioning = useMemo(() => {
    const daysDiff = moment(activity.date).diff(firstDateOnCalendar, 'days');
    return daysDiff > 20 ? PopupPosition.Right : PopupPosition.Left;
  }, [activity, firstDateOnCalendar]);

  if (activity.amWhereaboutsId === activity.pmWhereaboutsId) {
    return (
      <HolidayActivityFill ref={allDay.ref}
                           start={daysBetween(activity.date, firstDateOnCalendar)}
                           days={days}
                           textColour={Colours.black}
                           {...allDay.triggerProps}
                           title={activity.label}>
        <Contents>
          {activity.amImage && <WhereaboutsIconOutline label={''} image={activity.amImage} colour={'grey'} />}
          {props.children && <>{props.children}</>}
        </Contents>
        <CustomLeaveInfoPopup customLeaveDay={activity}
                              sideOfDay={SideOfDay.AllDay}
                              popupPositioning={popupPositioning}
                              isVisible={allDay.visible}
                              triggerRect={allDay.rect}
                              onMouseEnter={allDay.popupProps.onMouseEnter}
                              onMouseLeave={allDay.popupProps.onMouseLeave} />
      </HolidayActivityFill>
    )
  } else {
    return <>
      {activity.amWhereaboutsId && activity.amImage && <>
        <HolidayActivityFill ref={am.ref}
                             start={daysBetween(activity.date, firstDateOnCalendar)}
                             days={days}
                             startsWithHalfDay={true}
                             endsWithHalfDay={false}
                             textColour={Colours.black}
                             {...am.triggerProps}
                             title={activity.label}>
          <Contents>
            <WhereaboutsIconOutline label={''} image={activity.amImage} colour={'grey'} />
            {props.children && <>{props.children}</>}
          </Contents>
          <CustomLeaveInfoPopup customLeaveDay={activity}
                                sideOfDay={SideOfDay.AM}
                                popupPositioning={popupPositioning}
                                isVisible={am.visible}
                                triggerRect={am.rect}
                                onMouseEnter={am.popupProps.onMouseEnter}
                                onMouseLeave={am.popupProps.onMouseLeave} />
        </HolidayActivityFill>
      </>}
      {activity.pmWhereaboutsId && activity.pmImage && <>
        <HolidayActivityFill ref={pm.ref}
                             start={daysBetween(activity.date, firstDateOnCalendar)}
                             days={days}
                             startsWithHalfDay={true}
                             endsWithHalfDay={false}
                             textColour={Colours.black}
                             {...pm.triggerProps}
                             title={activity.label}>
          <Contents>
            <WhereaboutsIconOutline label={''} image={activity.pmImage} colour={'grey'} />
            {props.children && <>{props.children}</>}
          </Contents>
          <CustomLeaveInfoPopup customLeaveDay={activity}
                                sideOfDay={SideOfDay.PM}
                                popupPositioning={popupPositioning}
                                isVisible={pm.visible}
                                triggerRect={pm.rect}
                                onMouseEnter={pm.popupProps.onMouseEnter}
                                onMouseLeave={pm.popupProps.onMouseLeave} />
        </HolidayActivityFill>
      </>}
    </>
  }
}

interface Props {
  activity: any;
  children?: any;
  firstDateOnCalendar: Moment;
  weeksInMonth: number;
  birthday?: Birthday;
}

const Contents = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
`
